import { render, staticRenderFns } from "./ListText.vue?vue&type=template&id=0bd423df&"
import script from "./ListText.vue?vue&type=script&lang=js&"
export * from "./ListText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports